import React from 'react'
import { Typography } from 'antd'
import { i18n } from 'next-i18next'

interface PropsType {
  dateValue: string | Date,
  type?: any
}

const CustomDateColumn = ({ dateValue, type = null }: PropsType) => {

  const getDateFormatted = () => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' } as const
    const date = new Date(dateValue)
    return date.toLocaleString(i18n.language, options)
  }

  return (
    <div className={'centered-div'}>
      <Typography.Title level={5} type={type}>
        {getDateFormatted()}
      </Typography.Title>
    </div>
  )
}

export default CustomDateColumn
